import { Card } from 'primereact/card'

import { useStallableEffect } from '../../hooks/monitoring.ts'
import LoadingSpinner from './pure/LoadingSpinner.tsx'
import t from '../../tools/t.ts'

interface FullScreenLoadingProps {
    onStall?: () => Promise<void> | void
    stallThresholdMs?: number
}
/**
 * Show a full screen loading state, which doesn't care about any loading states.
 * It is the responsibility of the rendering component to determine
 *  whether it is loading and should render the loading state.
 * This component can handle a stallable effect and fires a handler if it stalls.
 */
export default function FullScreenLoading({ onStall, stallThresholdMs }: FullScreenLoadingProps) {
    useStallableEffect(onStall, stallThresholdMs)
    return (
        <div className="loading-screen">
            <Card className="loading-screen__card">
                <LoadingSpinner />
                <p className="loading-screen__text">{t('common_loading')}...</p>
            </Card>
        </div>
    )
}
